var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 54,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 77 54)",
    fill: "#F1EDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.601 97.509C153.051 97.6737 153.05 98.326 152.601 98.4905C146.726 100.641 144.641 102.725 142.49 108.601C142.326 109.05 141.674 109.05 141.509 108.601C139.357 102.728 137.274 100.644 131.399 98.491C130.949 98.3263 130.95 97.674 131.399 97.5095C137.274 95.3587 139.359 93.2747 141.51 87.3992C141.674 86.9498 142.326 86.9496 142.491 87.399C144.643 93.2723 146.726 95.3562 152.601 97.509Z",
    fill: "url(#paint0_linear_7320_105832)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5,
    cy: 23.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 70.5 23.5)",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5629 29.2793H135.721V65.4379L84.8734 116.286L48.7148 80.1273L99.5629 29.2793Z",
    stroke: "url(#paint1_linear_7320_105832)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.286 19.7148L135.721 29.2799",
    stroke: "url(#paint2_linear_7320_105832)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.34 51.519C114.314 51.519 113.482 50.6875 113.482 49.6618C113.482 48.6362 114.314 47.8047 115.34 47.8047",
    stroke: "url(#paint3_linear_7320_105832)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.34 51.519C116.366 51.519 117.197 50.6875 117.197 49.6618C117.197 48.6362 116.366 47.8047 115.34 47.8047",
    stroke: "url(#paint4_linear_7320_105832)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7320_105832",
    x1: 153.727,
    y1: 97.8033,
    x2: 114.531,
    y2: 110.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7320_105832",
    x1: 134.733,
    y1: 72.0693,
    x2: -7.36274,
    y2: 119.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7320_105832",
    x1: 145.177,
    y1: 24.419,
    x2: 129.556,
    y2: 29.6769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7320_105832",
    x1: 115.318,
    y1: 49.6314,
    x2: 112.035,
    y2: 50.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7320_105832",
    x1: 117.176,
    y1: 49.6314,
    x2: 113.892,
    y2: 50.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.79a4846e997cbf3cfd5b5c9bc998317c.svg";
export { ForwardRef as ReactComponent };